export function ModuleTitleLIFT() {
  return (
    <div className="flex items-baseline gap-3">
      <h2
        className="patria-module-title text-lg sm:text-xl"
        data-testid="lift-module-title"
      >
        LIFT
      </h2>
      <span className="text-xs uppercase tracking-widest text-charcoal-muted">
        Performance Evaluation
      </span>
    </div>
  );
}
